(function() {
    'use strict';

    angular.module('stats')
        .directive('cpClientStats', cpClientStats);

    cpClientStats.$inject = ['$state', 'clientStatsDataSrvc', 'dateFormatConst', 'momentSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc', 'previewStatsSrvc'];

    function cpClientStats($state, clientStatsDataSrvc, dateFormatConst, momentSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc, previewStatsSrvc) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/stats/directives/client-stats/client-stats.html',
            scope: {
                isDefault: '=',
                weeks: '=',
                months: '=',
                years: '=',
                shopVersion: '='
            },
            link: function(scope, element, attrs, controller) {
                var self = scope;

                self.loading = true;

                self.pageOpts = {
                    count: undefined,
                    page: 1,
                    pageSize: datatableDefaultPageSizeValueConst
                };
                self.dateRange = {daterangeFilter: {startDate: null, endDate: null}}
                self.shopVersionOptions = [];

                self.summaryCols = {
                    'netto': 'netto',
                    'no_orders': 'no_orders',
                    'no_ordered_products': 'no_ordered_products',
                    'no_subscriptions': 'no_subscriptions',
                    'favorites': 'favorites'
                }

                self.clientsStatsRows = [];
                self.clientsStatsCols = [{
                    title: 'Login',
                    value: 'login',
                    type: 'text',
                    searchable: true,
                    orderable: true,
                    type: 'link',
                    linkTo: 'layout.client.details',
                    linkParamProp: 'client_pk',
                }, {
                    title: 'Data rejestracji',
                    value: 'register_date',
                    type: 'text',
                    orderable: true
                }, {
                    title: 'Ostanie logowanie',
                    value: 'last_login',
                    type: 'date',
                    orderable: true
                }, {
                    title: 'Data ostatniego zamówienia "w realizacji"',
                    value: 'last_order',
                    type: 'date'
                }, {
                    title: 'Obrót netto',
                    value: 'netto',
                    type: 'decimal'
                }, {
                    title: 'Ilość zamówień',
                    value: 'no_orders',
                    type: 'text'
                }, {
                    title: 'Ilość zamówionych produktów',
                    value: 'no_ordered_products',
                    type: 'text',
                }, {
                    title: 'Średnia wartość zamówienia',
                    value: 'avg_order_value',
                    type: 'decimal'
                }, {
                    title: 'Średnia wartość produktu',
                    value: 'avg_product_value',
                    type: 'decimal'
                }, {
                    title: 'Subskrypcje',
                    value: 'no_subscriptions',
                    type: 'text',
                    onClick: previewStatsSrvc.previewSubscriptions,
                }, {
                    title: 'Ulubione produkty',
                    value: 'favorites',
                    type: 'text',
                    onClick: previewStatsSrvc.previewFavorites
                }, {
                    title: 'Grupa rabatowa',
                    value: 'discount_group',
                    type: 'text'
                }, {
                    title: 'Facebook like',
                    value: 'fb_like',
                    type: 'text'
                }, {
                    title: 'Polecenia',
                    value: 'recommendation',
                    type: 'text'
                }, {
                    title: 'Znajomi',
                    value: 'fb_friends',
                    type: 'text'
                }];

                self.searchQuery = {
                    pk: null,
                    name: null,
                    ordering: null
                };

                self.dateFormat = dateFormatConst.defaultPythonDate;
                self.filterData = {
                    min_date: null,
                    max_date: null,
                    shop_version: null
                };

                self.pageChange = pageChange;
                self.onSearchQueryChange = onSearchQueryChange;
                self.changeFilter = changeFilter;

                activate();

                function activate() {
                    self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
                    self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
                    self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
                    getShopVersions();
                    filterQuerySrvc.setLocationParams();
                    var minDate = moment(self.filterData.min_date, 'DD.MM.YYYY');
                    var maxDate = moment(self.filterData.max_date, 'DD.MM.YYYY');
                    if (!scope.isDefault){
                        if (scope.weeks) {
                            minDate = minDate.subtract(scope.weeks, 'w')
                            maxDate = maxDate.subtract(scope.weeks, 'w')
                        }
                        if (scope.months) {
                            minDate = minDate.subtract(scope.months, 'M')
                            maxDate = maxDate.subtract(scope.months, 'M')
                        }
                        if (scope.years) {
                            minDate = minDate.subtract(scope.years, 'y')
                            maxDate = maxDate.subtract(scope.years, 'y')
                        }
                        self.filterData.min_date = minDate.format(dateFormatConst.backendDate);
                        self.filterData.max_date = maxDate.format(dateFormatConst.backendDate);;
                    }

                    if (self.filterData.min_date) {
                        self.dateRange.daterangeFilter['startDate'] = minDate;
                        self.dateRange.daterangeFilter['endDate'] = maxDate;
                    }
                    getClientsStats();
                }

                function getShopVersions() {
                    clientStatsDataSrvc.shopVersions().$promise.then(
                        function(response) {
                            self.shopVersionOptions = response;
                        }
                    )
                }

                function getClientsStats(filterObj) {
                    self.loading = true;

                    if (!filterObj) {
                        filterObj = {
                            page: self.pageOpts.page,
                            page_size: self.pageOpts.pageSize,

                            pk: self.searchQuery.pk,
                            name: self.searchQuery.name,
                            ordering: self.searchQuery.ordering,

                            min_date: self.filterData.min_date || null,
                            max_date: self.filterData.max_date || null,
                            shop_version: self.filterData.shop_version || null
                        }
                    }
                    clientStatsDataSrvc.list(filterObj)
                        .$promise
                        .then(
                            function (response) {
                                self.clientsStatsRows = response.results;
                                self.pageOpts.count = response.count;
                            },
                            function (response) {
                                if (response.status === 404 && filterObj.page !== 1) {
                                    checkSearchSrvc.recall(filterObj, getClientsStats);
                                }
                            }
                        )
                        .finally(
                            function(response) {
                                self.loading = false;
                                return response;
                            }
                        );
                }

                function pageChange() {
                    filterQuerySrvc.updatePageOpts(self.pageOpts);
                    filterQuerySrvc.setLocationParams();
                    getClientsStats();
                }

                function onSearchQueryChange() {
                    filterQuerySrvc.updateSearchQuery(self.searchQuery);
                    filterQuerySrvc.setLocationParams();
                    getClientsStats();
                }

                function changeFilter() {
                    if (self.dateRange.daterangeFilter.startDate) {
                        self.filterData.min_date = self.dateRange.daterangeFilter.startDate.format(dateFormatConst.backendDate);
                        self.filterData.max_date = self.dateRange.daterangeFilter.endDate.format(dateFormatConst.backendDate)
                    } else {
                        self.filterData.min_date = null;
                        self.filterData.max_date = null;
                    }
                    if (scope.isDefault) {
                        filterQuerySrvc.updateFilterData(self.filterData);
                        filterQuerySrvc.setLocationParams();
                    }
                    getClientsStats();
                }
            }
        };
    }
})();
